import React from 'react';
import { Users, CheckCircle, AlertCircle, XCircle } from 'lucide-react';
import StatsGrid from '../shared/StatsGrid';

const VendorStats = ({ 
  totalVendors = 0,
  verifiedVendors = 0,
  pendingVendors = 0,
  rejectedVendors = 0,
  className = ''
}) => {
  const stats = [
    {
      key: 'total',
      title: 'Total Vendors',
      value: totalVendors,
      icon: Users,
      variant: 'default'
    },
    {
      key: 'verified',
      title: 'Verified',
      value: verifiedVendors,
      icon: CheckCircle,
      variant: 'success'
    },
    {
      key: 'pending',
      title: 'Pending',
      value: pendingVendors,
      icon: AlertCircle,
      variant: 'warning'
    },
    {
      key: 'rejected',
      title: 'Rejected',
      value: rejectedVendors,
      icon: XCircle,
      variant: 'danger'
    }
  ];

  return (
    <StatsGrid 
      stats={stats} 
      columns={4}
      className={className}
    />
  );
};

export default VendorStats;
